import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme-service';
import { Navbar } from './components/navbar/navbar';
import { Header } from './components/header/header';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';
import { navbarMenus } from './components/navbar/menuName';
import { Toast } from './components/toast/toast';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, Header, AsyncPipe, Toast, NgClass],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('portal-lojista');
  isProd = environment.production;
  routeTitle?: string;
  addPadding = true;

  currentPath$!: Observable<string>;

  constructor(
    private themeService: ThemeService,
    private router: Router,
  ) {
    this.themeService.getCurrentTheme();
  }

  ngOnInit(): void {
    this.currentPath$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        const urlPath = event.urlAfterRedirects.replace(/^\/+/, ''); // remove barra inicial
        const cleaned = urlPath.replace(/\/[a-f0-9\-]{36}$/, '');
        this.addPadding = cleaned == 'dev' || cleaned == 'settings' ? false : true;
        return this.findLabelByFullPath(cleaned) || 'Página';
      }),
    );
  }

  findLabelByFullPath(path: string): string | null {
    function search(menuItems: any[], parentPath = ''): string | null {
      for (const item of menuItems) {
        const fullPath = parentPath ? `${parentPath}/${item.path}` : item.path;

        if (fullPath === path) {
          return item.label;
        }

        if (item.children) {
          const found = search(item.children, fullPath);
          if (found) {
            return found;
          }
        }
      }

      return path.split('/')[2];
    }

    return search(navbarMenus);
  }
}
